import {
    ArrowRightOutlined,
    ArrowLeftOutlined,
    ExclamationCircleOutlined,
    DeleteOutlined,
    PaperClipOutlined,
} from '@ant-design/icons';
import { Form, Input, Button, Tooltip, Checkbox, Spin } from 'antd';
import { createRef, useState } from 'react';
import ModalDelete from '../../../components/Shared/modal/delete';
import useNotify from '../../../context/Notification/useNotify';
import GlobalService from '../../../services/Global.service';
import classNames from 'classnames';

export default function Stap4(props) {
    const ref = createRef();
    const { TextArea } = Input;
    const notify = useNotify();
    const [showAddon, setShowAddon] = useState(false);
    // const [loading, setLoading] = useState(false);
    const [loadingImage, setLoadingImage] = useState(false);
    const [loadingDoc, setLoadingDoc] = useState(false);
    const [message, setMessage] = useState('');
    const [fileTask, setFileList] = useState([]);
    const [deleteLoding, setDeleteLoding] = useState(false);
    const [openDelete, setOpenDelete] = useState({
        open: false,
        file: null,
    });
    const { setDocFile, docFile, setImageFile, imageFile } = props;
    //Previous and Next
    const onNextStep = () => {
        if (fileTask?.length <= 0 && props?.disbleUpload) {
            props.form.setFields([
                {
                    name: 'files',
                    errors: [
                        props.lang === 'TH'
                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                            : 'This field is required.',
                    ],
                },
            ]);
        } else {
            props.form
                .validateFields()
                .then(() => {
                    props.calProgress(80);
                    props.nextStep();
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };
    const onPreviousStep = () => {
        props.calProgress(60);
        props.previousStep();
    };

    const proofOfIdentity = [
        {
            id: '037519763d7111edb8780242ac120002',
            nameTH: (
                <>
                    กรณีสัญชาติไทย:
                    สำเนาบัตรประชาชนของเจ้าของข้อมูลส่วนบุคคลและ/หรือตัวแทน{' '}
                    <span>(โปรดลบข้อมูลศาสนาและหมู่โลหิตออกก่อนนำส่ง)</span>
                </>
            ),
            nameEN: 'Thai Nationality: A copy of Data Subject’s Identification card or Agent’s Identification card (Please erase or blackout your Religion and Blood Type data before sent to the company)',
        },
        {
            id: '0611de6c3d7111edb8780242ac120002',
            nameTH: 'กรณีต่างชาติ สำเนาหนังสือเดินทางเจ้าของข้อมูลส่วนบุคคลและ/หรือตัวแทน ',
            nameEN: 'Foreign Nationality: A copy of Data Subject’s or Agent’s Passport (If any)',
        },
        {
            id: '08594eee3d7111edb8780242ac120002',
            nameTH: 'หนังสือมอบอำนาจ (กรณีผู้ขอเป็นตัวแทนของเจ้าของข้อมูลส่วนบุคคล) ',
            nameEN: 'Power of Attorney (In case of an Agent of a Data Subject) ',
        },
        {
            id: '0aaaffd03d7111edb8780242ac120002',
            nameTH: 'กรณีผู้เยาว์: สำเนาสูติบัตร หรือสำเนาทะเบียนบ้าน',
            nameEN: 'In the case of a minor: a copy of the birth certificate or a copy of the house registration',
        },
        {
            id: '0cb3e6023d7111edb8780242ac120002',
            nameTH: 'กรณีบุคคลไร้ความสามารถ หรือเสมือนไร้ความสามารถ: สำเนาหลักฐานการแต่งตั้งให้เป็นตัวแทนของเจ้าของข้อมูล',
            nameEN: 'In the case of an incompetent person Incompetent or quasi-incompetent: a copy of proof of designation as a representative of the data subject.',
        },
        {
            id: '0ecb41743d7111edb8780242ac120002',
            nameTH: 'หลักฐานอื่นๆ',
            nameEN: 'Other evidence',
        },
    ];

    const allowedType = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/msword', // .doc
        'application/pdf', // .pdf
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'image/png', // .png
        'image/jpeg', // .jepg
        'image/jpg', // .jepg
    ];

    const deleteFile = async (file) => {
        const imageType = [
            'png', // .png
            'jpeg', // .jepg
            'jpg', // .jepg
        ];
        const id = file?.fileStorageId;
        if (imageType.includes(file?.fileType)) {
            props?.setImageFile(
                props?.imageFile.filter((file) => file.fileStorageId !== id)
            );
            setFileList(fileTask.filter((file) => file.fileStorageId !== id));
            setOpenDelete({
                open: false,
                file: null,
            });
            setDeleteLoding(false);
        } else {
            props?.setDocFile(
                props?.docFile.filter((file) => file.fileStorageId !== id)
            );
            setFileList(fileTask.filter((file) => file.fileStorageId !== id));
            setOpenDelete({
                open: false,
                file: null,
            });
            setDeleteLoding(false);
        }
    };

    const onChange = async (e) => {
        if (
            e.target.files.length &&
            e.target.files.length + fileTask.length <= 10
        ) {
            props.form.setFields([
                {
                    name: 'files',
                    errors: [],
                },
            ]);
            for (let i = 0; i < e.target.files.length; i++) {
                const fileSize = e.target.files[i].size / 1024 / 1024;
                const fileType = e.target.files[i].type;
                if (fileSize >= 2) {
                    notify({
                        type: 'error',
                        title:
                            props.lang === 'EN'
                                ? 'Upload Fail'
                                : 'อัปโหลดล้มแหลว',
                        description:
                            props.lang === 'EN'
                                ? '(Your file cannot be larger than 2 MB.)'
                                : '(ไม่สามารถอัปโหลดไฟล์ได้เกิน 2 MB.)',
                        closeable: true,
                    });
                    return;
                }
                if (!allowedType.includes(fileType)) {
                    notify({
                        type: 'error',
                        title:
                            props.lang === 'EN'
                                ? 'Upload Fail'
                                : 'อัปโหลดล้มแหลว',
                        description:
                            props.lang === 'EN'
                                ? 'Upload error file type is wrong'
                                : 'อัปโหลดไม่สำเร็จ ประเภทไฟล์ไม่ถูกต้อง',
                        closeable: true,
                    });
                    return;
                }
                // if (fileSize <= 10 && allowedType.includes(fileType)) {
                //     setValueInput(e.target.value);
                // }
            }
            const allowedTypeDoc = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                'application/msword', // .doc
                'application/pdf', // .pdf
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel', // .xls
            ];
            const allowedTypeImage = [
                'image/png', // .png
                'image/jpeg', // .jepg
                'image/jpg', // .jepg
            ];
            let bodyFormDocData = new FormData();
            let imageList = [];
            // let image = [];
            for (let i = 0; i < e.target.files.length; i++) {
                let ImageData = new FormData();
                const file = e.target.files[i];
                const fileType = file.type;
                ImageData.append('image', file);
                ImageData.append('fileName', file.name);
                ImageData.append('action', 'image-create-application');
                if (allowedTypeImage.includes(fileType)) {
                    try {
                        await setLoadingImage(true);
                        await setMessage('upload image...');
                        const { data } = await GlobalService.uploadPublicImage(
                            ImageData
                        );
                        await setLoadingImage(false);
                        if (data?.resultData?.imageId) {
                            const item = {
                                fileStorageId: data.resultData?.imageId,
                                fileName: data.resultData?.imageName,
                                fileType: data.resultData?.imageType,
                            };
                            // image.push(data?.resultData);
                            imageList.push(item);
                        }
                    } catch (error) {
                        await setLoadingImage(false);
                        console.log(error);
                    }
                } else if (allowedTypeDoc.includes(fileType)) {
                    const formfile = e.target.files[i];
                    const utf8Name = encodeURIComponent(formfile.name);
                    const header = `form-data; name="uploadFile"; filename*=UTF-8''${utf8Name}`;
                    bodyFormDocData.append('doc', formfile, header);
                    // bodyFormDocData.append('fileName', formfile?.name);
                }
            }
            setImageFile([...imageFile, ...imageList]);
            const docLength = Array.from(bodyFormDocData.keys()).length;

            if (docLength > 0) {
                bodyFormDocData.append('action', 'ds-request-step-4');
                try {
                    await setLoadingDoc(true);
                    await setMessage('upload document...');
                    const { data } = await GlobalService.uploadPublicDoc(
                        bodyFormDocData
                    );
                    await setLoadingDoc(false);
                    if (data?.resultData) {
                        // setFileList([...fileTask, ...data?.resultData]);
                        setDocFile([...docFile, ...data?.resultData]);

                        imageList = imageList.concat(...data?.resultData);
                    }
                } catch (error) {
                    notify({
                        type: 'error',
                        title:
                            props.lang === 'EN'
                                ? 'Upload Fail'
                                : 'อัปโหลดล้มแหลว',
                        description:
                            props.lang === 'EN'
                                ? 'Fail to upload'
                                : 'อัปโหลดไฟล์ไม่สำเร็จ',
                        closeable: true,
                    });
                    await setLoadingDoc(false);
                    console.log(error);
                    return;
                }
            }
            console.log([...fileTask, ...imageList]);
            const value = [...fileTask, ...imageList];
            props?.form?.setFieldValue('files', value);
            setFileList([...fileTask, ...imageList]);
        } else if (e.target.files.length + fileTask.length >= 10) {
            notify({
                type: 'error',
                title: props.lang === 'EN' ? 'Upload Fail' : 'อัปโหลดล้มแหลว',
                description:
                    props.lang === 'EN'
                        ? 'Upload error file type is wrong'
                        : 'สามารถอัปโหลดไฟล์สูงสุด 10 ไฟล์เท่านั้น',
                closeable: true,
            });
        }
    };
    const handleDragEnter = (e) => {
        e.preventDefault();
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDragLeave = () => {};
    const handleOnDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        console.log(droppedFiles);
        const item = {
            target: {
                files: e.dataTransfer.files,
            },
        };
        onChange(item);
    };

    return (
        <div
            className="rounded-md p-5 h-full"
            style={{
                backgroundColor: props?.customStyle?.bgColor, //bgColor
            }}
        >
            <div className="space-y-3">
                <div
                    className="text-xl font-bold text-[#7B67FB] px-3"
                    style={{
                        color: props?.fontStyle?.textCardColor,
                    }}
                >
                    4.{' '}
                    {props.lang === 'TH'
                        ? 'หลักฐานหรือข้อมูลให้เพียงพอต่อการดำเนินการ'
                        : 'Sufficient evidence or information for the operation'}
                </div>
                <div style={{ border: '1px solid #DBDBDB' }}></div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    className="px-3"
                    name="step4"
                    form={props.form}
                    layout="vertical"
                >
                    <div
                        className="font-bold text-xl"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                    >
                        {props.lang === 'TH'
                            ? 'หลักฐานการยืนยันตัวตน'
                            : 'Proof of identity'}
                    </div>
                    <div
                        className="font-semibold pb-1.5 pt-2"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                            fontSize: props?.fontStyle?.fontSize,
                        }}
                    >
                        {props.lang === 'TH'
                            ? 'หลักฐานการยืนยันตัวตน'
                            : 'Proof of identity'}
                        <span
                            className="ml-1.5 pb-1 text-[#ff4d4f] font-medium text-sm lead-[1px]"
                            style={{ fontFamily: 'SimSun, sans-serif' }}
                        >
                            *
                        </span>
                    </div>
                    <Form.Item
                        noStyle={showAddon}
                        style={{ margin: '0 0 24px' }}
                        name={'proofOfIdentity'}
                        // label={
                        //     <>
                        //         <div
                        //             className="font-semibold"
                        //             style={{
                        //                 color: props?.fontStyle
                        //                     ?.textCardColor,
                        //                 fontSize:
                        //                     props?.fontStyle?.fontSize,
                        //             }}
                        //         >
                        //             หลักฐานการยืนยันตัวตน
                        //         </div>
                        //     </>
                        // }
                        rules={[
                            {
                                required: true,
                                message:
                                    props.lang === 'TH'
                                        ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                        : 'This field is required.',
                            },
                        ]}
                    >
                        <Checkbox.Group
                            onChange={() => {
                                if (
                                    props.form
                                        .getFieldsValue()
                                        .proofOfIdentity?.includes(
                                            '0ecb41743d7111edb8780242ac120002'
                                        )
                                ) {
                                    setShowAddon(true);
                                } else {
                                    setShowAddon(false);
                                }
                            }}
                            className="w-full space-y-2"
                        >
                            {/* {props?.proofOfIdentity?.map((item) => ( */}
                            {proofOfIdentity?.map((item) => (
                                <div key={item?.id}>
                                    <Checkbox
                                        style={{
                                            color: props?.fontStyle
                                                ?.textCardColor,
                                            fontSize:
                                                props?.fontStyle?.fontSize,
                                        }}
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {props.lang === 'EN'
                                            ? item?.nameEN
                                            : item?.nameTH}
                                        {/* {item?.name} */}
                                    </Checkbox>
                                </div>
                            ))}
                        </Checkbox.Group>
                    </Form.Item>

                    {showAddon && (
                        <Form.Item
                            className="pt-3"
                            name={'proofOfIdentityAddon'}
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <TextArea
                                size="large"
                                className="w-5/6"
                                maxLength={60}
                                autoSize={{ minRows: 1 }}
                                placeholder="โปรดระบุ"
                            ></TextArea>
                        </Form.Item>
                    )}

                    {props?.customForm?.display?.evidence && (
                        <>
                            <div className="flex items-center space-x-2  pb-3">
                                <div
                                    className="font-bold text-xl"
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                    }}
                                >
                                    {props.lang === 'TH'
                                        ? 'หลักฐานประกอบคำขอใช้สิทธิ'
                                        : 'Supporting Document'}
                                </div>
                                <div>
                                    <Tooltip
                                        placement="right"
                                        overlayClassName="min-w-[30%]"
                                        title={
                                            <>
                                                {props.lang === 'TH'
                                                    ? 'เอกสารหรือหลักฐานเพิ่มเติมในการประกอบคำขอใช้สิทธิ เช่น หนังสือสัญญา , หนังสือการให้ความยินยอม ฯลฯ'
                                                    : 'Documents or additional evidence in support of the request for exercise of rights, such as Contract, letter of consent, etc.'}
                                            </>
                                        }
                                    >
                                        <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                            <ExclamationCircleOutlined />
                                        </a>
                                    </Tooltip>
                                </div>
                            </div>
                            <Form.Item
                                // style={{ margin: '0 0 24px' }}
                                name={'evidence'}
                            >
                                <Checkbox
                                    checked={props?.disbleUpload}
                                    onChange={(e) => {
                                        props?.setDisbleUpload(
                                            e.target.checked
                                        );
                                        props.form.resetFields(['file']);
                                    }}
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                >
                                    {props.lang === 'TH'
                                        ? 'หลักฐานประกอบคำขอใช้สิทธิ'
                                        : 'Supporting Document'}
                                </Checkbox>
                            </Form.Item>
                            {props?.disbleUpload && (
                                <div className="sm:w-full md:w-[55%] space-y-2">
                                    {/* Dragger */}

                                    <Form.Item name="files">
                                        <div>
                                            <button
                                                type="button"
                                                onDragEnter={handleDragEnter}
                                                onDragOver={handleDragOver}
                                                onDragLeave={handleDragLeave}
                                                onDrop={handleOnDrop}
                                                onClick={() =>
                                                    ref.current.click()
                                                }
                                                className={'cursor-pointer'}
                                            >
                                                <Button
                                                    disabled={
                                                        fileTask?.length >=
                                                            10 ||
                                                        loadingImage ||
                                                        loadingDoc
                                                    }
                                                    // loading = {loadingImage || loadingDoc}
                                                    className="min-w-[200px] h-auto border-[2.2px] rounded-lg border-dashed border-[#95A0A8] text-center hover:border-[#7B67FB] duration-150 cursor-pointer"
                                                    // icon={<PlusCircleOutlined />}
                                                >
                                                    <Spin
                                                        className="min-w-[200px]"
                                                        spinning={
                                                            loadingDoc ||
                                                            loadingImage
                                                        }
                                                        tip={message}
                                                    >
                                                        <div className="pt-[10px]">
                                                            <UploadLogo />
                                                        </div>
                                                        <p
                                                            style={{
                                                                visibility:
                                                                    loadingImage ||
                                                                    loadingDoc
                                                                        ? 'hidden'
                                                                        : 'visible',
                                                            }}
                                                            className="ant-upload-text"
                                                        >
                                                            Drop file here,
                                                            paste or{' '}
                                                            <span
                                                                className={classNames(
                                                                    'text-[#7B67FB]',
                                                                    {
                                                                        'text-[#00000040]':
                                                                            fileTask?.length >=
                                                                            10,
                                                                    }
                                                                )}
                                                            >
                                                                browse file
                                                            </span>
                                                        </p>
                                                        <p
                                                            style={{
                                                                visibility:
                                                                    loadingImage ||
                                                                    loadingDoc
                                                                        ? 'hidden'
                                                                        : 'visible',
                                                            }}
                                                            className="text-10 font-light"
                                                        >
                                                            {props.lang ===
                                                            'EN' ? (
                                                                <span>
                                                                    *Can upload
                                                                    10 files,
                                                                    max size of
                                                                    2 MB.
                                                                    <br />
                                                                    (Allowed
                                                                    file types :
                                                                    .jpg, .jpeg,
                                                                    .png, .docx,
                                                                    .xlsx, .pdf)
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    สามารถอัปโหลดไฟล์สูงสุด
                                                                    10 ไฟล์,
                                                                    ขนาดสูงสุด 2
                                                                    MB.
                                                                    <br />
                                                                    (ประเภทไฟล์ที่อนุญาต
                                                                    : .jpg,
                                                                    .jpeg, .png,
                                                                    .docx,
                                                                    .xlsx, .pdf)
                                                                </span>
                                                            )}
                                                        </p>
                                                    </Spin>
                                                </Button>
                                                <input
                                                    ref={ref}
                                                    // disabled={fileTask?.length === 10}
                                                    onChange={onChange}
                                                    type="file"
                                                    style={{
                                                        display: 'none',
                                                    }}
                                                    multiple
                                                    accept={allowedType.join(
                                                        ','
                                                    )}
                                                    // value={valueInput}
                                                />
                                            </button>
                                        </div>
                                    </Form.Item>
                                    {fileTask?.map((file, i) => {
                                        return (
                                            <div
                                                key={file.fileStorageId}
                                                className="flex justify-between"
                                            >
                                                <div
                                                    className="text-new space-x-2 cursor-pointer w-[95%] flex items-start"
                                                    // onClick={() =>
                                                    //     downloadFile(file)
                                                    // }
                                                >
                                                    <PaperClipOutlined className="pt-1" />
                                                    <div
                                                        className="overflow-hidden font-semibold"
                                                        style={{
                                                            wordWrap:
                                                                'break-word',
                                                        }}
                                                    >
                                                        {file.fileName}.
                                                        {file.fileType}
                                                    </div>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        // console.log(file);
                                                        setOpenDelete({
                                                            open: true,
                                                            file: file,
                                                        });
                                                    }}
                                                    className="text-[#95A0A8] cursor-pointer"
                                                >
                                                    <DeleteOutlined />
                                                </button>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </>
                    )}
                    <div className="flex space-x-4 py-4">
                        <Button
                            // className="text-[#7B67FB] border-[#7B67FB]"
                            style={{
                                borderColor: props?.customStyle?.buttonColor,
                                color: props?.customStyle?.buttonColor,
                            }}
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                            className="w-[120px]"
                        >
                            <ArrowLeftOutlined /> ย้อนกลับ
                        </Button>
                        <Button
                            type="primary"
                            style={{
                                backgroundColor:
                                    props?.customStyle?.buttonColor,
                                color: props?.fontStyle?.textButtonColor,
                                borderColor: props?.customStyle?.buttonColor,
                            }}
                            size="large"
                            onClick={() => {
                                onNextStep();
                            }}
                            className="w-[120px]"
                        >
                            ถัดไป <ArrowRightOutlined />
                        </Button>
                    </div>
                </Form>
            </div>
            <ModalDelete
                loading={deleteLoding}
                open={openDelete?.open}
                handelClose={() => {
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                }}
                handelOk={() => {
                    setDeleteLoding(true);
                    const file = openDelete.file;
                    deleteFile(file);
                }}
            />
        </div>
    );
}

const UploadLogo = () => (
    <svg
        width="42"
        height="40"
        viewBox="0 0 42 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_1415_188256)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2448 4C17.985 4.00879 14.8363 5.02029 12.3675 6.85175C10.4755 8.25425 9.10464 10.0817 8.75142 11.9156C4.61167 12.7019 1.48462 15.8044 1.48462 19.5507C1.48462 23.9028 5.70342 27.375 10.8238 27.375H20.0098V16.1274L14.7091 20.6898C14.4772 20.8893 14.1627 21.0013 13.8347 21.0013C13.5068 21.0013 13.1922 20.8893 12.9603 20.6898C12.7284 20.4902 12.5982 20.2196 12.5982 19.9375C12.5982 19.6554 12.7284 19.3848 12.9603 19.1852L20.3704 12.8102C20.4851 12.7113 20.6214 12.6328 20.7715 12.5792C20.9215 12.5257 21.0824 12.4981 21.2448 12.4981C21.4072 12.4981 21.5681 12.5257 21.7181 12.5792C21.8682 12.6328 22.0045 12.7113 22.1192 12.8102L29.5293 19.1852C29.7612 19.3848 29.8914 19.6554 29.8914 19.9375C29.8914 20.2196 29.7612 20.4902 29.5293 20.6898C29.2974 20.8893 28.9828 21.0013 28.6549 21.0013C28.3269 21.0013 28.0124 20.8893 27.7805 20.6898L22.4798 16.1274V27.375H32.8243C37.3049 27.375 41.005 24.3363 41.005 20.5176C41.005 17.0411 37.9372 14.2085 34.0049 13.7304C33.4047 8.24788 27.8892 4 21.2448 4ZM20.0098 34.8125V27.375H22.4798V34.8125C22.4798 35.0943 22.3497 35.3645 22.1181 35.5638C21.8865 35.7631 21.5723 35.875 21.2448 35.875C20.9173 35.875 20.6031 35.7631 20.3715 35.5638C20.1399 35.3645 20.0098 35.0943 20.0098 34.8125Z"
                fill="#C4C4C4"
            />
        </g>
        <defs>
            <clipPath id="clip0_1415_188256">
                <rect
                    width="41.0847"
                    height="40"
                    fill="white"
                    transform="translate(0.45752)"
                />
            </clipPath>
        </defs>
    </svg>
);
